var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("送信が完了しました")]),_c('el-row',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('el-col',{attrs:{"span":15}},[_c('value-list')],1)],1),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('v-btn',{on:{"click":_vm.homeBackClick}},[_vm._v("ホームへ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }